export {AssetTaskViewActivityContainer as AssetTaskViewActivity} from './AssetTaskViewActivityContainer';
export {ProjectTaskViewActivityContainer as ProjectTaskViewActivity} from './ProjectTaskViewActivityContainer';
export {TemplateTaskViewActivityContainer as TemplateTaskViewActivity} from './TemplateTaskViewActivityContainer';



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskViewActivity/index.js